import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './Routes';
import BaseStyles from './assets/BaseStyles';
import NormalizeStyles from './assets/NormalizeStyles';
import { CacheBuster } from './CacheBuster';
import 'semantic-ui-css/semantic.min.css';

const Container = () => (
  <CacheBuster
    currentVersion={window.localStorage.getItem('cacheVersion')}
    isEnabled={true}
    isVerboseMode={true}
  >
    <NormalizeStyles />
    <BaseStyles />
    <Routes />
  </CacheBuster>
);

ReactDOM.render(<Container />, document.getElementById('root'));
